import { render, staticRenderFns } from "./SongEdit.vue?vue&type=template&id=41e1be7a&"
import script from "./SongEdit.vue?vue&type=script&lang=js&"
export * from "./SongEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports